import type { ReactNode } from "react";

import { useGuard } from "../../hooks/auth/useGuard";

type UserIsDevProps = {
  fallback?: ReactNode;
  children: ReactNode;
};

/**
 * Renders children when the active person is a dev (`isDev` or role `dev`).
 *
 *   <UserIsDev>...</UserIsDev>
 */
export default function UserIsDev({ fallback = null, children }: UserIsDevProps) {
  const { userIsDev } = useGuard();

  return <>{userIsDev() ? children : fallback}</>;
}
